import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LinkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.5 4.5H4.5C3.83696 4.5 3.20107 4.76339 2.73223 5.23223C2.26339 5.70107 2 6.33696 2 7V19.5C2 20.163 2.26339 20.7989 2.73223 21.2678C3.20107 21.7366 3.83696 22 4.5 22H17C17.663 22 18.2989 21.7366 18.7678 21.2678C19.2366 20.7989 19.5 20.163 19.5 19.5V14.5M14.5 2H22M22 2V9.5M22 2L9.5 14.5"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

LinkIcon.displayName = 'LinkIcon';
